module.exports = __webpack_public_path__ + "cobrand_myaquent_client_banner_aquents_book.jpg";